module.exports = __webpack_public_path__ + "static/media/offices (1).6832f75e.webp";